import { TerrainType } from '@common/data/TerrainType';

export interface TerrainParticleConfig {
  /** RGB colours (0xRRGGBB) to pick from */
  colours: number[];
  /** Maximum number of particles to emit per footstep */
  quantity: number;
}

export const FOOTSTEP_PARTICLE_CONFIG: Partial<Record<TerrainType, TerrainParticleConfig>> = {
  grass: {
    // Mix of light and dark greens and some earthy tones
    colours: [0x4d8f58, 0x3e7a48, 0x6bb576, 0x4a3c2c],
    quantity: 8,
  },
  sand: {
    colours: [0xad9e8c, 0x93948c, 0x9a9686, 0xc1bcac],
    quantity: 10,
  },
};
